import { HttpEvent, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { API_CONFIG } from '../config/api.config';

export const apiLoggingInterceptor: HttpInterceptorFn = (request, next) => {
  const apiConfig = inject(API_CONFIG);
  const shouldLogRequests = apiConfig.logging.request;
  const shouldLogResponses = apiConfig.logging.response;

  if (!shouldLogRequests && !shouldLogResponses) {
    return next(request);
  }

  const start = performance.now();

  if (shouldLogRequests) {
    console.debug('[API][Request]', {
      method: request.method,
      url: request.urlWithParams,
      hasBody: request.body !== null && request.body !== undefined
    });
  }

  return next(request).pipe(
    tap({
      next: (event: HttpEvent<unknown>) => {
        if (!shouldLogResponses) {
          return;
        }

        if (event.type !== HttpEventType.Response) {
          return;
        }

        console.debug('[API][Response]', {
          method: request.method,
          url: request.urlWithParams,
          status: event.status,
          durationMs: Math.round(performance.now() - start)
        });
      },
      error: (error: unknown) => {
        if (!shouldLogResponses) {
          return;
        }

        console.debug('[API][Error]', {
          method: request.method,
          url: request.urlWithParams,
          error,
          durationMs: Math.round(performance.now() - start)
        });
      }
    })
  );
};
